import { render, staticRenderFns } from "./NewRichTextEditor.vue?vue&type=template&id=0ddcb0cc&scoped=true"
import script from "./NewRichTextEditor.vue?vue&type=script&lang=js"
export * from "./NewRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=0ddcb0cc&prod&scoped=true&lang=css&external"
import style1 from "./NewRichTextEditor.vue?vue&type=style&index=1&id=0ddcb0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcb0cc",
  null
  
)

export default component.exports